var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slide, toast, ToastContainer as ToastContainerFromLibrary, } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import styled, { css } from 'styled-components';
import { Elevation } from '../../theme/elevation';
import { ThemeFamilies } from '../../theme/families';
import getThemeBreakpoints from '../../utils/getThemeBreakpoints';
import Icon, { IconName } from '../Icon';
import { ToastContentTypography } from '../Typography/toastContent';
import { ToastTitleTypography } from '../Typography/toastTitle';
import Button, { ButtonVariants } from '../Button';
var CustomToastContainer = styled(ToastContainerFromLibrary).attrs({
    icon: false,
    transition: Slide,
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  .Toastify__close-button {\n    padding-top: 6px;\n  }\n"], ["\n  ", "\n\n  ",
    "\n\n  .Toastify__close-button {\n    padding-top: 6px;\n  }\n"])), getThemeBreakpoints('toastContainer'), function (_a) {
    var theme = _a.theme;
    var toastFamilies = theme.families.toast;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      .Rapyd__toast {\n        box-shadow: ", ";\n        border-radius: 16px 4px 16px 16px;\n      }\n\n      .Rapyd__error_border {\n        border: 1px solid ", ";\n      }\n\n      .Rapyd__info_border {\n        border: 1px solid ", ";\n      }\n\n      .Rapyd__success_border {\n        border: 1px solid ", ";\n      }\n\n      .Rapyd__warning_border {\n        border: 1px solid ", ";\n      }\n    "], ["\n      .Rapyd__toast {\n        box-shadow: ", ";\n        border-radius: 16px 4px 16px 16px;\n      }\n\n      .Rapyd__error_border {\n        border: 1px solid ", ";\n      }\n\n      .Rapyd__info_border {\n        border: 1px solid ", ";\n      }\n\n      .Rapyd__success_border {\n        border: 1px solid ", ";\n      }\n\n      .Rapyd__warning_border {\n        border: 1px solid ", ";\n      }\n    "])), theme.elevation[Elevation.DEPTH3], toastFamilies[ThemeFamilies.ERROR].main, toastFamilies[ThemeFamilies.INFO].main, toastFamilies[ThemeFamilies.SUCCESS].main, toastFamilies[ThemeFamilies.WARNING].main);
});
var ToastBody = function (_a) {
    var title = _a.title, content = _a.content, type = _a.type, staticSize = _a.staticSize, actionProps = _a.actionProps;
    return (_jsxs(InnerContentWrapper, { children: [_jsx(IconWrapper, __assign({ "data-testid": "toast-icon-wrapper-" + type, type: type }, { children: getIconByToastType(type) }), void 0),
            _jsxs(ToastTextContainer, __assign({ staticSize: staticSize }, { children: [_jsx(ToastTitle, __assign({ staticSize: staticSize, type: type }, { children: title }), void 0),
                    _jsx(ToastContent, __assign({ staticSize: staticSize, type: type }, { children: content }), void 0),
                    actionProps ? (_jsx(StyledActionButton, __assign({ onClick: function (e) {
                            actionProps.onClick();
                            e.stopPropagation();
                        }, variant: ButtonVariants.TEXT }, { children: actionProps.text }), void 0)) : null] }), void 0)] }, void 0));
};
var defaultToastOptions = function (type) { return ({
    hideProgressBar: true,
    className: "Rapyd__toast Rapyd__" + type + "_border",
}); };
var showToast = function (props) {
    var type = props.type, title = props.title, content = props.content, rest = __rest(props, ["type", "title", "content"]);
    var jsx = ToastBody({ title: title, content: content, type: type });
    return toast[type](jsx, __assign(__assign({}, defaultToastOptions(type)), rest));
};
var InnerContentWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  & > :not(:last-child) {\n    margin-right: 8px;\n  }\n"], ["\n  display: flex;\n  & > :not(:last-child) {\n    margin-right: 8px;\n  }\n"])));
var IconWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n  border-radius: 12px;\n  width: 34px;\n  height: 34px;\n"], ["\n  position: relative;\n  background-color: ", ";\n  border-radius: 12px;\n  width: 34px;\n  height: 34px;\n"])), function (_a) {
    var theme = _a.theme, type = _a.type;
    return getToastColorsByType(theme, type).light;
});
var ToastTextContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  & > :not(:last-child) {\n    margin-bottom: 5px;\n  }\n"], ["\n  ", "\n\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  & > :not(:last-child) {\n    margin-bottom: 5px;\n  }\n"])), getThemeBreakpoints('toastTextContainer'));
var ToastTitle = styled(ToastTitleTypography)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n\n  color: ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  flex: 1 0 18px;\n"], ["\n  ", "\n\n  color: ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  flex: 1 0 18px;\n"])), getThemeBreakpoints('toastTextWidth'), function (_a) {
    var theme = _a.theme, type = _a.type;
    return getToastColorsByType(theme, type).text;
});
var ToastContent = styled(ToastContentTypography)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n\n  color: ", ";\n  overflow-y: scroll;\n  flex: 1 1 100%;\n  padding-right: 5px;\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    border-left: 4px #7f7f7f solid;\n    background-clip: padding-box;\n  }\n"], ["\n  ", "\n\n  color: ", ";\n  overflow-y: scroll;\n  flex: 1 1 100%;\n  padding-right: 5px;\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    border-left: 4px #7f7f7f solid;\n    background-clip: padding-box;\n  }\n"])), getThemeBreakpoints('toastTextWidth'), function (_a) {
    var theme = _a.theme, type = _a.type;
    return getToastColorsByType(theme, type).text;
});
var CenteredIcon = styled(Icon)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: ", ";\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, type = _a.type;
    return getToastColorsByType(theme, type).main;
});
var getIconByToastType = function (type) {
    var DefaultIcon = _jsx(CenteredIcon, { name: IconName.INFO_SQ, type: type }, void 0);
    if (!type) {
        return DefaultIcon;
    }
    switch (type) {
        case 'info':
            return DefaultIcon;
        case 'success':
            return _jsx(CenteredIcon, { name: IconName.CHECK_SQ, type: type }, void 0);
        case 'error':
            return _jsx(CenteredIcon, { name: IconName.DELETE_SQ, type: type }, void 0);
        case 'warning':
            return _jsx(CenteredIcon, { name: IconName.WARNING_2, type: type }, void 0);
        default:
            return DefaultIcon;
    }
};
var StyledActionButton = styled(Button)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-left: auto;\n  width: max-content;\n  font-size: 13px;\n"], ["\n  margin-left: auto;\n  width: max-content;\n  font-size: 13px;\n"])));
var getToastColorsByType = function (theme, type) {
    return theme.families.toast[type] || theme.families.toast[RapydToastTypes.INFO];
};
/* Exported Artifacts */
export var RapydToastTypes;
(function (RapydToastTypes) {
    RapydToastTypes["INFO"] = "info";
    RapydToastTypes["WARNING"] = "warning";
    RapydToastTypes["ERROR"] = "error";
    RapydToastTypes["SUCCESS"] = "success";
})(RapydToastTypes || (RapydToastTypes = {}));
export { CustomToastContainer, showToast };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
